import { AuthenticatedLayout } from "../../../layouts/AuthenticatedLayout/AuthenticatedLayout";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { TaxSlipsGlobalSettings } from "../../../components/GlobalSettings";

export const TaxSlipsGlobalSettingsPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Global Variables"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[{text: 'Global Variables', navigateTo: '/global-variables'}]}
      mainContents={<TaxSlipsGlobalSettings testId="global-variables-page" />}
    />
  );
};
